module.exports = __webpack_public_path__ + "img/Frost_Daggerfish_demo.6601b592.gif";